import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Box, Card, CardContent, Divider, Stack, Typography, } from "@mui/material";
import { PlayerAvatar } from "../players/PlayerAvatar";
import { PlayerNameLink } from "../players/PlayerDisplayNameLink";
import { SeeAllButton } from "../utils/CardActions";
// Overlapping yellow + red cards — the disciplinary "Most Cards" glyph. Drawn
// inline so it stays crisp and theme-independent (the card colours are semantic,
// not palette colours).
const YellowRedCards = () => (_jsxs("svg", { width: 40, height: 40, viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: [_jsx("rect", { x: 5, y: 4, width: 10, height: 15, rx: 1.6, fill: "#F5C518", transform: "rotate(-12 10 11.5)" }), _jsx("rect", { x: 9, y: 5, width: 10, height: 15, rx: 1.6, fill: "#E53935", transform: "rotate(11 14 12.5)" })] }));
export const StatsStack = ({ stats }) => {
    const mostCapped = [...stats].sort((a, b) => b.matchesPlayed - a.matchesPlayed)[0];
    const topScorer = [...stats].sort((a, b) => b.goalsScored - a.goalsScored)[0];
    const mostCards = [...stats].sort((a, b) => b.redCards !== a.redCards
        ? b.redCards - a.redCards
        : b.yellowCards - a.yellowCards)[0];
    const tiles = [
        {
            label: "Most Capped",
            icon: _jsx(DirectionsRunIcon, { fontSize: "large", sx: { color: "#D4A017" } }),
            value: mostCapped ? `${mostCapped.matchesPlayed} games` : "",
            player: mostCapped?.player,
        },
        {
            label: "Top Scorer",
            icon: _jsx(SportsSoccerIcon, { fontSize: "large" }),
            value: topScorer ? `${topScorer.goalsScored} goals` : "",
            player: topScorer?.player,
        },
        {
            label: "Most Cards",
            icon: _jsx(YellowRedCards, {}),
            value: mostCards
                ? `${mostCards.redCards} red / ${mostCards.yellowCards} yellow`
                : "",
            player: mostCards?.player,
        },
    ];
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }, children: [_jsx(Typography, { variant: "h6", children: "Stats" }), _jsx(SeeAllButton, { to: "stats" })] }), _jsx(Divider, { sx: { marginBottom: 2 } }), _jsx(Stack, { spacing: 2, divider: _jsx(Divider, {}), children: tiles.map((tile) => (_jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [tile.icon, _jsx(Typography, { variant: "subtitle2", color: "text.secondary", children: tile.label }), tile.player ? (_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(PlayerAvatar, { pictureUrl: tile.player.picture, name: tile.player.name, playerId: tile.player.id, size: 28 }), _jsx(PlayerNameLink, { id: tile.player.id, name: tile.player.name ?? undefined, nationality: tile.player.nationality })] })) : (_jsx(Typography, { variant: "subtitle1", children: "N/A" })), _jsx(Typography, { variant: "body2", color: "text.secondary", children: tile.value })] }, tile.label))) })] }) }));
};
